import { AbsoluteFill, Easing, interpolate, useCurrentFrame } from 'remotion';

// Types
import { CurvedLinesBackgroundProps } from '../../types';

// Constants
import { CURVED_LINES_DEFAULT_STYLE, CURVED_LINES_PATH } from '../../constants';
import { CLAMP_BOTH } from '@/constants/animations';

export const CurvedLinesBackground = ({
  path = CURVED_LINES_PATH,
  lineStyle,
  viewBox = '0 0 1920 1080',
  animation,
  exitOpacity = 1,
}: CurvedLinesBackgroundProps) => {
  const frame = useCurrentFrame();

  const isAnimated = !!animation;
  const duration = animation?.duration ?? 40;
  const delay = animation?.delay ?? 0;

  const dashOffset = isAnimated
    ? interpolate(frame, [delay, delay + duration], [1, 0], {
        ...CLAMP_BOTH,
        easing: Easing.inOut(Easing.ease),
      })
    : 0;

  return (
    <AbsoluteFill className="pointer-events-none" style={{ opacity: exitOpacity }}>
      <svg
        className="size-full"
        viewBox={viewBox}
        preserveAspectRatio="xMidYMid slice"
      >
        <path
          d={path}
          pathLength={1}
          style={{
            ...CURVED_LINES_DEFAULT_STYLE,
            ...lineStyle,
            ...(isAnimated && {
              strokeDasharray: 1,
              strokeDashoffset: dashOffset,
            }),
          }}
        />
      </svg>
    </AbsoluteFill>
  );
};
